var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('h1',{staticClass:"text-center mt-10 text-h2"},[_vm._v("Não Autorizado")]),_c('v-icon',{staticClass:"text-h1 mt-3",attrs:{"color":"red"}},[_vm._v("mdi-account-off-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }